import { render, staticRenderFns } from "./DeliveryEdit.vue?vue&type=template&id=3acce3e8&"
import script from "./DeliveryEdit.vue?vue&type=script&lang=js&"
export * from "./DeliveryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports